import { faSparkles, faMemo, faCircleInfo, faCircleXmark, faTriangleExclamation, faCircleCheck } from '@awesome.me/kit-3777c2145e/icons/classic/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Alert as Alert$1 } from 'react-bootstrap';
import { classNames } from '../../utils/class-names.js';

const Alert = ({ className, variant = "primary", icon = "auto", size, alignItems = "center", children, ...props })=>{
    let iconContent = icon;
    if (icon === "auto") {
        switch(variant){
            case "success":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faCircleCheck
                });
                break;
            case "warning":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faTriangleExclamation
                });
                break;
            case "danger":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faCircleXmark
                });
                break;
            case "info":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faCircleInfo
                });
                break;
            case "light":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faMemo
                });
                break;
            case "gold":
                iconContent = /*#__PURE__*/ React.createElement(FontAwesomeIcon, {
                    icon: faSparkles
                });
                break;
            default:
                iconContent = undefined;
        }
    }
    let content = children;
    if (iconContent) {
        content = /*#__PURE__*/ React.createElement("div", {
            className: `d-flex flex-nowrap align-items-${alignItems}`
        }, /*#__PURE__*/ React.createElement("div", {
            className: "alert-icon"
        }, iconContent), /*#__PURE__*/ React.createElement("div", {
            className: "align-self-center"
        }, children));
    }
    const classes = classNames(size && `alert-${size}`, className);
    return /*#__PURE__*/ React.createElement(Alert$1, {
        className: classes,
        variant: variant,
        ...props
    }, content);
};

export { Alert };
//# sourceMappingURL=Alert.js.map
